import { trackEvent } from '@99designs/common/utils/platform';
import EmailSubscriptionService from '@99designs/common/utils/platform/emailSubscriptionService';
import { DISMISSED_EMAIL_CAPTURE_FORM } from 'common/consts/emailCaptureEvents';
import Bugsnag from 'common/utils/Bugsnag';
import { post } from 'common/utils/xhr';
import { ActionContext } from 'fluxible';
import UrlStore from 'launch/stores/UrlStore';

export function dismissEmailCollection(ctx: ActionContext) {
    const url = urlFor(ctx, 'updateDraft');

    ctx.dispatch('DISMISS_EMAIL_COLLECTION');

    // Post empty email to skip
    const xhr = post(url, { email: '' });

    return new Promise(resolve => {
        xhr.end((err, res) => {
            if (err) {
                Bugsnag.notify({
                    name: 'Failed xhr:skipEmailCollection',
                    message: `Request to ${url} failed to skip email-collection in Visual Brief`,
                });
            } else {
                trackEvent(DISMISSED_EMAIL_CAPTURE_FORM, {
                    acquisition_source: 'launch',
                });
            }
            resolve();
        });
    });
}

interface SubmitEmailPayload {
    email: string;
    subscribeToMarketing: boolean;
}

export function submitEmail(
    ctx: ActionContext,
    { email, subscribeToMarketing }: SubmitEmailPayload
) {
    const url = urlFor(ctx, 'updateDraft');

    ctx.dispatch('SUBMIT_EMAIL_COLLECTION');

    const xhr = post(url, { email });

    return new Promise(resolve => {
        xhr.end((err, res) => {
            if (err) {
                Bugsnag.notify({
                    name: 'Failed xhr:submitEmail',
                    message: `Request to ${url} failed to submit email to email-collection in Visual Brief`,
                });
            } else {
                const draftData = JSON.parse(res.text);
                const emailService = new EmailSubscriptionService();

                emailService
                    .subscribe({
                        email: email,
                        acquisitionSource: 'launch',
                        subscribeToMarketing,
                        customData: {
                            category_key: draftData.category_key,
                            draft_id: draftData.draft_hash,
                        },
                    })
                    .catch(() => {
                        Bugsnag.notify({
                            name: 'Failed xhr:submitEmail',
                            message: `Request to ${url} failed to submit email to email-collection in Visual Brief`,
                        });
                    });
            }

            resolve();
        });
    });
}

function urlFor(ctx: ActionContext, key: string) {
    return ctx.getStore<UrlStore>(UrlStore).urlFor(key);
}
